import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TimesheetCalendarSourceType } from 'api/timesheets';
import { ReactComponent as AtomGCalLogo } from 'assets/svgs/google-calendar.svg';
import { ReactComponent as AtomOutlookCal } from 'assets/svgs/outlook.svg';
import { GoogleLogin, MicrosoftLogin } from 'components/atoms/vendor-loign';
import { ProductiveHeading06 } from 'components/styles';
import { useTimesheetIntegrationOauthQuery } from 'queries/timesheets/calendar-integration-provider';

interface Props {
  sourceType: TimesheetCalendarSourceType;
}
const GCalLogo = styled(AtomGCalLogo)`
  width: 48px;
  height: 48px;
`;
const OutlookCal = styled(AtomOutlookCal)`
  width: 48px;
  height: 48px;
`;

const Wrapper = styled.div`
  height: 258px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 var(--spacing-09);
  align-items: flex-start;
`;

const Content = styled.div`
  margin-top: var(--spacing-05);
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: var(--spacing-03);
`;

const Title = styled.div`
  ${ProductiveHeading06};
`;

const Description = styled.div``;
const ButtonWrapper = styled.div`
  flex-grow: 1;
`;

export const SetupCalendar: FC<Props> = ({ sourceType }) => {
  const frontendRedirectPath = window.location.pathname;

  const { data: authMeta, isLoading } = useTimesheetIntegrationOauthQuery(
    sourceType,
    frontendRedirectPath,
  );
  const googleOAuth = authMeta?.oauthUrl;

  const isGcal = sourceType === TimesheetCalendarSourceType.GoogleCalendar;
  const LoginButton = isGcal ? GoogleLogin : MicrosoftLogin;

  return (
    <Wrapper>
      {isGcal ? <GCalLogo /> : <OutlookCal />}
      <Content>
        <Title>
          <FormattedMessage id="ai_fill.calendar_connect.title" />
        </Title>
        <Description>
          {isGcal ? (
            <FormattedMessage id="ai_fill.calendar_connect.google.description" />
          ) : (
            <FormattedMessage id="ai_fill.calendar_connect.outlook.description" />
          )}
        </Description>
        <ButtonWrapper>
          <LoginButton href={googleOAuth!} isLoading={isLoading} />
        </ButtonWrapper>
      </Content>
    </Wrapper>
  );
};
